import type { LandingPersona, LandingPersonaId } from '@/hooks/useLandingPersona'
import LandingVibeSwitcher from './LandingVibeSwitcher'

interface Props {
  persona: LandingPersona
  personaId: LandingPersonaId
  setPersonaId: (id: LandingPersonaId) => void
  PERSONAS: Record<LandingPersonaId, LandingPersona>
  onSignIn: () => void
  onCta: () => void
}

export default function LandingNav({
  persona,
  personaId,
  setPersonaId,
  PERSONAS,
  onSignIn,
  onCta,
}: Props) {
  return (
    <nav className="lp-nav">
      <div className="lp-container lp-nav-inner">
        <a
          href="#top"
          className="lp-wordmark"
          style={{ textDecoration: 'none' }}
          onClick={(e) => {
            e.preventDefault()
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }}
        >
          <span>{persona.name}</span>
        </a>

        <div style={{ flex: 1 }} />

        <div className="lp-tab-pill" role="tablist" aria-label="Choose persona">
          {(Object.values(PERSONAS) as LandingPersona[]).map((p) => {
            const active = personaId === p.id
            return (
              <button
                key={p.id}
                className={`lp-tab-btn ${active ? 'active' : ''}`}
                onClick={() => setPersonaId(p.id)}
                role="tab"
                aria-selected={active}
                style={
                  active
                    ? { background: p.primary, color: '#000', boxShadow: `0 0 18px ${p.glow}` }
                    : undefined
                }
              >
                {p.name}
              </button>
            )
          })}
        </div>

        <LandingVibeSwitcher
          persona={persona}
          personaId={personaId}
          setPersonaId={setPersonaId}
          PERSONAS={PERSONAS}
        />

        <button
          className="lp-btn-ghost"
          onClick={onSignIn}
          style={{ display: 'inline-flex' }}
        >
          Sign in
        </button>
        <button className="lp-btn-primary" onClick={onCta}>
          Get Started
        </button>
      </div>
    </nav>
  )
}
